import { DiscussionDto, DiscussionId, EtxeApiSlugs } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { DiscussionsAgentConnector } from './agent/discussions-agent.connector';
import { DiscussionsOwnerConnector } from './owner/discussions-owner.connector';

export class DiscussionsConnector extends ApiConnector<DiscussionDto, DiscussionDto, DiscussionId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.DISCUSSIONS);
  }

  owner = () => new DiscussionsOwnerConnector(this.apiCaller, this.apiPrefix, this.slug);
  agent = () => new DiscussionsAgentConnector(this.apiCaller, this.apiPrefix, this.slug);
}
